export default "__VITE_ASSET__BVT2xpe___"